import {
  getHeaderDataRepo,
  postClearEntityCacheRepo,
  getLocationRepo,
} from "../repositories/premium/common";

export const headerData = (data) => {
  return async (dispatch) => {
    await getHeaderDataRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_HEADER_DATA_SUCCESS",
            payload: response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_HEADER_DATA_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_HEADER_DATA_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getLocation = (data) => {
  return (dispatch) => {
    getLocationRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_LOCATION_SUCCESS",
            payload: response?.data?.data,
          });
        } else {
          dispatch({
            type: "GET_LOCATION_FAILURE",
            payload: response?.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({ type: "GET_LOCATION_FAILURE", payload: error?.message });
        }
      });
  };
};

export const postClearEntityCache = (data) => {
  return (dispatch) => {
    postClearEntityCacheRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CLEAR_ENTITY_CACHE_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "POST_CLEAR_ENTITY_CACHE_FAILURE",
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_CLEAR_ENTITY_CACHE_FAILURE",
            payload: error?.message,
          });
        }
      });
  };
};
